import { createFileRoute } from '@tanstack/react-router';
import { Alert, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PlatformRole, hasRole, useSession } from '../auth/session';
import { UsersScreen } from '../features/users/UsersScreen';
import { BackLink } from '../components/BackLink';

export const Route = createFileRoute('/tenants_/$tenantId_/users')({
  component: UsersPage,
});

function UsersPage() {
  const { t } = useTranslation('tenants');
  const { tenantId } = Route.useParams();
  const { data: session } = useSession();

  const canAdmin = hasRole(session, PlatformRole.TenantAdmin, tenantId);
  const canView = hasRole(session, PlatformRole.Viewer, tenantId);

  return (
    <Stack gap="sm">
      <BackLink to="/tenants/$tenantId" params={{ tenantId }} search={{ tab: 'settings' }} />

      {!canView ? (
        <Alert color="red" title={t('noAccessUsersTitle')}>
          {t('noRoleBody')}
        </Alert>
      ) : (
        <>
          {!canAdmin && (
            <Alert color="blue" variant="light" title={t('readOnlyTitle')}>
              {t('readOnlyUsersBody')}
            </Alert>
          )}
          <UsersScreen tenantId={tenantId} canAdmin={canAdmin} />
        </>
      )}
    </Stack>
  );
}
